import viteLogo from '/vite.svg';

const Spinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="relative w-20 h-20">
        <img
          src={viteLogo}
          alt="Loading..."
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10"
          style={{
            animation: 'spin 2s linear infinite'
          }}
        />
        <div className="absolute inset-0">
          <div className="w-full h-full rounded-full border-4 border-blue-500 border-t-transparent animate-spin"></div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
